import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";
import type { DraftDto } from "./createDraft.actions";

export type RenameDraftPayload = {
    id: string;
    projectName: string;
};

export type RenameDraftResponse = {
    status: number;
    data: DraftDto;
};

export const renameDraft = async (payload: RenameDraftPayload): Promise<DraftDto> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const { id, projectName } = payload;

    const { data } = await gatewayPageBuilder.patch<RenameDraftResponse>(
        `page-builder/drafts/${id}/name`,
        { projectName },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
